import { render, staticRenderFns } from "./NewDeals.vue?vue&type=template&id=167dc061&"
import script from "./NewDeals.vue?vue&type=script&lang=js&"
export * from "./NewDeals.vue?vue&type=script&lang=js&"
import style0 from "./NewDeals.vue?vue&type=style&index=0&id=167dc061&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports